<div id="case-detailed-lawyer" class="container-fluid">

    <ng-container *ngIf="case">

        <case-lawyer-readonly *permissions="Permission.SMP_CASE_EDIT_LAWYER_SECTION; logic: LogicOp.NAND"
                              [idPrefix]="idPrefix"
                              [caseId]="case.id">
        </case-lawyer-readonly>

        <case-lawyer-editable *permissions="Permission.SMP_CASE_EDIT_LAWYER_SECTION"
                              [idPrefix]="idPrefix"
                              [caseId]="case.id">
        </case-lawyer-editable>

    </ng-container>
    
</div>
